// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Collapsible container web component.
 * @author James Reid
 */

// @ts-check

// @@no-imports

// @@body
class CollapsibleContainer extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.querySelector("div.collapsible")
            ?.addEventListener("click", () => { this.toggle() })
    }

    toggle() {
        this.classList.contains("collapsed") ? this.expand() : this.collapse()
    }

    collapse() {
        this.classList.add("collapsed")

        if (this.dataset.collapsedText) {
            /** @type {HTMLParagraphElement} */ (this
                .querySelector("div.collapsible p"))
                .innerText = this.dataset.collapsedText
        }
    }

    expand() {
        this.classList.remove("collapsed")

        if (this.dataset.expandedText) {
            /** @type {HTMLParagraphElement} */ (this
                .querySelector("div.collapsible p"))
                .innerText = this.dataset.expandedText
        }

        // eslint-disable-next-line eqeqeq -- Allows checking nullish.
        if (this.dataset.scrollIntoView != null) {
            this.scrollIntoView({ behavior: "smooth" })
        }
    }


    static get customName() {
        return "collapsible-container"
    }
}

// @@exports
export { CollapsibleContainer }
